import React, { useState } from 'react';
import { useLanguage } from '../LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export const Faq = () => {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-24 bg-slate-50" data-id="element-30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="text-center mb-16" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-33">
            {t.faq.title}
          </h2>
          <p className="text-lg text-slate-600" data-id="element-34">{t.faq.subtitle}</p>
        </div>

        <div className="space-y-4" data-id="element-35">
          {t.faq.items.map((item, index) => <div key={index} className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-36">
              <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-inset" aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} data-id="element-37">
                <span className="font-semibold text-lg text-slate-900 pr-8" data-id="element-38">
                  {item.q}
                </span>
                <ChevronDown className={`flex-shrink-0 text-indigo-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-39" />
              </button>

              <AnimatePresence initial={false} data-id="element-40">
                {openIndex === index && <motion.div id={`faq-answer-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-41">
                    <div className="px-6 pb-6 pt-2 text-slate-600 leading-relaxed border-t border-slate-100" data-id="element-42">
                      {item.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};